import axios from "axios";

export const fetchAllDevices = async (cancelToken) => {
    try {
        const { data } = await axios.get(`/api/devices`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};

export const fetchDevice = async (deviceId, cancelToken) => {
    try {
        const { data } = await axios.get(`/api/devices/${deviceId}`, { cancelToken })
        return data
    } catch (error) {
        throw error
    }
};

export const editDeviceNickname = (id, nickname) => {
    let data = {_id: id, nickname}
    return axios.put(`/api/devices/nickname`, data)
}

export const editDeviceType = (id, type) => {
    let data = {_id: id, type}
    return axios.put(`/api/devices/type`, data)
}
export const setDeviceAuthorization = (id, authorization) => {
    let data = { _id: id, authorization}
    return axios.put(`/api/devices/authorization`, data)
}